import { render } from "./ManagerActions.vue?vue&type=template&id=7898966e&scoped=true"
import script from "./ManagerActions.vue?vue&type=script&lang=js"
export * from "./ManagerActions.vue?vue&type=script&lang=js"

import "./ManagerActions.vue?vue&type=style&index=0&id=7898966e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7898966e"]])

export default __exports__